import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const InstagramServices: React.FC = () => <PlatformServicePage platform="instagram" />;
export default InstagramServices;
